var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import prettyBytes from "pretty-bytes";
import { useUserStore } from "@/stores/userStore";
import { formatDistanceToNowStrict } from "date-fns";
import { toRef, ref, computed, onMounted } from "vue";
import { useDetailedHistory } from "./usesDetailedHistory.js";
import { useConfig } from "@/composables/config";
import { HistoryFilters } from "@/components/History/HistoryFilters.js";
import PreferredStorePopover from "./PreferredStorePopover.vue";
import SelectPreferredStore from "./SelectPreferredStore.vue";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryCounter',
    props: {
        history: null,
        isWatching: { type: Boolean, default: false },
        lastChecked: { default: () => new Date() },
        filterText: { default: "" },
        showControls: { type: Boolean, default: false }
    },
    emits: ["update:filter-text", "reloadContents"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const { config } = useConfig();
        const { currentUser } = storeToRefs(useUserStore());
        const { historySize, numItemsActive, numItemsDeleted, numItemsHidden } = useDetailedHistory(toRef(props, "history"));
        const reloadButtonCls = ref("fa fa-sync");
        const reloadButtonTitle = ref("");
        const reloadButtonVariant = ref("link");
        const showPreferredObjectStoreModal = ref(false);
        const historyPreferredObjectStoreId = ref(props.history.preferred_object_store_id);
        const niceHistorySize = computed(() => prettyBytes(historySize.value));
        onMounted(() => {
            updateTime();
            // update every second
            setInterval(updateTime, 1000);
        });
        function onDashboard() {
            router.push({ name: "HistoryOverview", params: { historyId: props.history.id } });
        }
        function setFilter(filter) {
            let newFilterText = "";
            let settings = {};
            if (filter == "") {
                settings = {
                    deleted: false,
                    visible: true,
                };
            }
            else {
                const newVal = getCurrentFilterVal(filter) === "any" ? HistoryFilters.defaultFilters[filter] : "any";
                settings = {
                    deleted: filter === "deleted" ? newVal : getCurrentFilterVal("deleted"),
                    visible: filter === "visible" ? newVal : getCurrentFilterVal("visible"),
                };
            }
            newFilterText = HistoryFilters.applyFiltersToText(settings, props.filterText);
            emit("update:filter-text", newFilterText);
        }
        function getCurrentFilterVal(filter) {
            return HistoryFilters.getFilterValue(props.filterText, filter);
        }
        function updateTime() {
            const diffToNow = formatDistanceToNowStrict(props.lastChecked, { addSuffix: true });
            const diffToNowSec = Date.now().valueOf() - props.lastChecked.valueOf();
            // if history isn't being watched or hasn't been watched/polled for over 2 minutes
            if (!props.isWatching || diffToNowSec > 120000) {
                reloadButtonTitle.value = "Last refreshed " + diffToNow + ". Consider reloading the page.";
                reloadButtonVariant.value = "danger";
            }
            else {
                reloadButtonTitle.value = "Last refreshed " + diffToNow;
                reloadButtonVariant.value = "link";
            }
        }
        function reloadContents() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("reloadContents");
                reloadButtonCls.value = "fa fa-sync fa-spin";
                setTimeout(() => {
                    reloadButtonCls.value = "fa fa-sync";
                }, 1000);
            });
        }
        function onUpdatePreferredObjectStoreId(preferredObjectStoreId) {
            showPreferredObjectStoreModal.value = false;
            // ideally this would be pushed back to the history object somehow
            // and tracked there... but for now this is only component using
            // this information.
            historyPreferredObjectStoreId.value = preferredObjectStoreId;
        }
        return { __sfc: true, props, router, config, currentUser, historySize, numItemsActive, numItemsDeleted, numItemsHidden, reloadButtonCls, reloadButtonTitle, reloadButtonVariant, showPreferredObjectStoreModal, historyPreferredObjectStoreId, niceHistorySize, emit, onDashboard, setFilter, getCurrentFilterVal, updateTime, reloadContents, onUpdatePreferredObjectStoreId, PreferredStorePopover, SelectPreferredStore };
    }
});
